<div class="screen-element waterpressure-screen">
	<div class="title">{{getTranslator().tr(getTitle())}}</div>
	<div class="subtitle" [ngClass]="{'light':hasParameter('lightSubtitle')}">{{getTranslator().tr(getSubtitle())}}</div>
	<div class="dashboard-center">
		<div *ngIf="dashIcon" class="icon dashIcon {{dashIcon}}"></div>
		<div class="value">{{value}}</div>
		<div class="unit">{{unit}}</div>
		<div class="icon iconPressure"></div>
	</div>
	
	<div class="pressureGauge">
		<div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13]" class="gaugeUnit" [ngClass]="{'off':i>5}"></div>
	</div>
	<div class="rangeLimitMin"></div>
	<div class="rangeLimitMax"></div>
	<div class="rangeLimitMinText">1.0&nbsp;&nbsp;MIN</div>
	<div class="rangeLimitMaxText">MAX&nbsp;&nbsp;3.5</div>
	<div class="text text-1"><text-widget [color]="'white'" [text]="getText(0)"></text-widget></div>
</div>
